import React from 'react';
import {Text, View} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import HookFormRadioInput from 'src/hook-form-wrapper/radio-input';
import {useStyle} from 'src/providers/style';
import {Typography} from 'src/styles';
import {
  InputProps,
  OutputProps,
  PreviewProps,
} from 'src/modules/form-builder/utils/types';
import {DataItem} from 'src/design-system';
import {Separator} from 'src/common-components/atoms';
import {uuid} from 'src/common-utils/uuid';

export const Details = ({required, label, options}: any) => {
  const styles = useStyle();

  return (
    <View>
      <View style={[styles.paddingMVertical]}>
        <Text style={[Typography.P3]}>{required ? label + '*' : label}</Text>
      </View>
      {options?.map((item, index) => (
        <View key={`radio-item-${index}`} style={[styles.row]}>
          <Icon
            name={index === 0 ? 'radiobox-marked' : 'radiobox-blank'}
            size={20}
          />
          <Separator width={10} />
          <View
            style={[
              styles.paddingSMVertical,
              styles.paddingRight,
              styles.width,
            ]}>
            <Text style={[Typography.LABEL]}>{item.label}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};

export const Definition = () => ({
  name: 'Radio Button',
  label: '',
  placeholder: '',
  componentType: 'RADIO',
  icon: 'radiobox-marked',
  options: [
    {
      value: uuid(),
      label: 'Option 1',
    },
    {
      value: uuid(),
      label: '',
    },
  ],
  helper: '',
  required: false,
});

export const Input = ({item, name}: InputProps) => {
  return (
    <View>
      <HookFormRadioInput
        name={name}
        items={item.options}
        label={item.label}
        required={item.required}
        rules={
          item.required
            ? {
                required: 'This field is required.',
              }
            : {}
        }
      />
    </View>
  );
};

export const Output = ({item, value}: OutputProps) => {
  const styles = useStyle();

  return (
    <DataItem>
      <Text style={[Typography.H6]}>{item.label}</Text>
      <View style={[styles.container]}>
        {item?.options?.map(radioItem => (
          <View style={[styles.row, styles.paddingRight]}>
            <Icon
              name={
                value?.includes(radioItem.value)
                  ? 'radiobox-marked'
                  : 'radiobox-blank'
              }
              size={20}
              style={[styles.paddingMRight]}
            />
            <Text style={[Typography.P3, styles.paddingXSTop]}>
              {radioItem.label}
            </Text>
          </View>
        ))}
      </View>
    </DataItem>
  );
};

export const Preview = ({item}: PreviewProps) => {
  const styles = useStyle();

  return (
    <View>
      <View style={[styles.paddingMVertical]}>
        <Text style={[Typography.P3]}>{item.label}</Text>
      </View>
      {item.options?.map((option, index) => (
        <View style={[styles.row]}>
          <Icon
            name={index === 0 ? 'radiobox-marked' : 'radiobox-blank'}
            size={20}
            style={[styles.paddingMRight]}
          />
          <View
            style={[
              styles.paddingSMVertical,
              styles.paddingRight,
              styles.width,
            ]}>
            <Text style={[Typography.LABEL]}>{option.label}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};
